import photo1 from "../assets/images/events/IMG_2892.jpg";
import photo2 from "../assets/images/events/IMG_2898.jpg";
import photo3 from "../assets/images/events/IMG_2901.jpg";
import photo4 from "../assets/images/events/IMG_2905.jpg";
import photo5 from "../assets/images/events/IMG_2917.jpg";
import photo6 from "../assets/images/events/IMG_2922.jpg";
import photo7 from "../assets/images/events/IMG_2928.jpg";
import photo8 from "../assets/images/events/IMG_2936.jpg";
import photo9 from "../assets/images/events/IMG_2945.jpg";
import photo10 from "../assets/images/events/IMG_2958.jpg";
import photo11 from "../assets/images/events/IMG_2983.jpg";
import photo12 from "../assets/images/events/IMG_3002.jpg";
import gbg1 from "../assets/images/events/gbg/gbg-01.jpg";
import gbg2 from "../assets/images/events/gbg/gbg-02.jpg";
import gbg3 from "../assets/images/events/gbg/gbg-03.jpg";
import gbg4 from "../assets/images/events/gbg/gbg-04.jpg";
import gbg5 from "../assets/images/events/gbg/gbg-05.jpg";
import gbg6 from "../assets/images/events/gbg/gbg-06.jpg";
import gbg7 from "../assets/images/events/gbg/gbg-07.jpg";
import gbg8 from "../assets/images/events/gbg/gbg-08.jpg";
import gbg9 from "../assets/images/events/gbg/gbg-09.jpg";
import gbg10 from "../assets/images/events/gbg/gbg-10.jpg";
import gbg11 from "../assets/images/events/gbg/gbg-11.jpg";
import gbg12 from "../assets/images/events/gbg/gbg-12.jpg";

export const eventGallery = [
  photo1,
  photo2,
  photo3,
  photo4,
  photo5,
  photo6,
  photo7,
  photo8,
  photo9,
  photo10,
  photo11,
  photo12,
];

export const gothenburgGallery = [
  gbg1,
  gbg2,
  gbg3,
  gbg4,
  gbg5,
  gbg6,
  gbg7,
  gbg8,
  gbg9,
  gbg10,
  gbg11,
  gbg12,
];

export type SiteEvent = {
  slug: string;
  title: string;
  status: "upcoming" | "past";
  date: string; // ISO date for sorting
  dateLabel: string;
  timeLabel?: string;
  location: string;
  description: string;
  highlights?: { title: string; text: string }[];
  gallery?: string[];
};

export const events: SiteEvent[] = [
  {
    slug: "shaping-platform-engineering-copenhagen",
    title: "Shaping the Future of Platform Engineering — Copenhagen",
    status: "upcoming",
    date: "9999-12-31",
    dateLabel: "Date to be announced",
    location: "Copenhagen · Venue to be announced",
    description:
      "We're bringing the Platform Engineering afternoon to Copenhagen. Date, venue and time are being finalised — register your interest and we'll make sure you're first to know.",
  },
  {
    slug: "shaping-platform-engineering-2025",
    title: "Shaping the Future of Platform Engineering",
    status: "past",
    date: "2026-05-20",
    dateLabel: "Wednesday, May 20, 2026",
    timeLabel: "13:00 – 16:00, followed by optional networking",
    location:
      "Downtown Camper by Scandic · Brunkebergstorg 9 · Stockholm",
    description:
      "An afternoon focused on Platform Engineering and Internal Developer Platforms — unlocking organisations' potential, boosting effectiveness and accelerating innovation at scale.",
    highlights: [
      {
        title: "Keynote",
        text: "The evolving landscape of Platform Engineering.",
      },
      {
        title: "Live Demo",
        text: "Red Hat Developer Hub and Trusted Software Supply Chain in action.",
      },
      {
        title: "Real-World Case Study",
        text: "Lessons learned directly from your peers.",
      },
    ],
    gallery: eventGallery,
  },
  {
    slug: "shaping-platform-engineering-gothenburg-2026",
    title: "Shaping the Future of Platform Engineering — Gothenburg",
    status: "past",
    date: "2026-03-12",
    dateLabel: "Thursday, March 12, 2026",
    timeLabel: "13:00 – 16:00, followed by optional networking",
    location: "Kungsportsavenyn 29 · Gothenburg",
    description:
      "We brought the Platform Engineering afternoon to Gothenburg — a half-day on Internal Developer Platforms, with keynotes, a live Red Hat Developer Hub demo, and real-world stories from teams building platforms at scale.",
    highlights: [
      {
        title: "Keynote",
        text: "The evolving landscape of Platform Engineering.",
      },
      {
        title: "Live Demo",
        text: "Red Hat Developer Hub and Trusted Software Supply Chain in action.",
      },
      {
        title: "Real-World Case Study",
        text: "Lessons learned directly from your peers.",
      },
    ],
    gallery: gothenburgGallery,
  },
];

export const upcomingEvents = events.filter((e) => e.status === "upcoming");
export const pastEvents = events
  .filter((e) => e.status === "past")
  .sort((a, b) => b.date.localeCompare(a.date));
